import api from './api';

export interface NextQuizItem {
  id: number;
  student: number;
  item_type: 'quiz' | 'container';
  quiz: number | null;
  quiz_data?: any;
  container: number | null;
  container_data?: any;
  excluded_quiz_ids: number[];
  container_quizzes_data: any[] | null;
  order: number;
  created_at: string;
  updated_at: string;
}

class NextQuizItemService {
  async getByStudent(studentId: number): Promise<NextQuizItem[]> {
    const response = await api.get('/next-quiz-items/', {
      params: { student: studentId }
    });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async bulkReplace(studentId: number, items: Partial<NextQuizItem>[]): Promise<NextQuizItem[]> {
    const response = await api.post('/next-quiz-items/bulk_replace/', {
      student: studentId,
      items: items
    });
    return response.data;
  }

  async clearStudent(studentId: number): Promise<void> {
    await api.delete(`/next-quiz-items/clear-student/${studentId}/`);
  }
}

const nextQuizItemService = new NextQuizItemService();
export default nextQuizItemService;
